var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"remaining-day-wrapper"},[_c('i18n',{attrs:{"path":"promotion.referFriends.daysRemaining"},scopedSlots:_vm._u([{key:"day",fn:function(){return [_vm._v(" "+_vm._s(_vm.remainingTime)+" ")]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }